import type { NearBodyPartType } from './types';

export const NearBodyPartTextMap: Record<NearBodyPartType, string> = {
  WAIST: '배꼽',
  HIP: '엉덩이',
  KNEE: '무릎',
  ANKLE: '발목',
  INSTEP: '발등',
};
